module.exports = __webpack_public_path__ + "media/images/flags/by-2a5a613b2f9a2e44e0ab3bc628150e7b.svg";